/** @return {string} */
export function getRootDomain(domain) {
  if (domain == null || typeof domain !== "string") return domain;

  const root = domain.split(".").slice(1).join(".");
  return root;
}